import { useState, useEffect, useCallback } from 'react';
import { Language, getTranslation } from '../i18n/translations';

export function useLanguage() {
  const [lang, setLangState] = useState<Language>(() => {
    return (localStorage.getItem('appLanguage') as Language) || 'en';
  });

  useEffect(() => {
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((newLang: Language) => {
    localStorage.setItem('appLanguage', newLang);
    setLangState(newLang);
  }, []);

  const t = useCallback((key: string) => getTranslation(lang, key), [lang]);

  return { lang, setLang, t };
}
